import page from "page";
import { currentPath } from "./global-state";
import { getSession } from "./session";
import { clearThrottledCallStore } from "./ui/throttle";
import * as IntervalManager from "./interval-manager";
import el from "@cypherpotato/el";
import { pageQuery } from "./util";
import { sendClientContext, trackVisitedUrl } from "./context-tracking";

let clientContextTimer = null;

export function map(url, render) {
    page(url, async (ctx) => {

        ctx.session = getSession();
        ctx.query = ctx.querystring && Object.fromEntries([...new URLSearchParams(ctx.querystring).entries()]) || {};

        IntervalManager.clearAllIntervals();
        el.state.clearAllPoolingStates();

        const [rendered] = await Promise.all([
            render(ctx)
        ]);

        window.scrollTo({ top: 0 });

        currentPath.value = url;
        trackVisitedUrl(ctx.path);

        if (rendered instanceof Node) {
            app.innerHTML = "";
            app.appendChild(rendered);
        }

        void app.offsetHeight;

        clearTimeout(clientContextTimer);
        clientContextTimer = setTimeout(sendClientContext, 1000);

        delete window._dragHandler;
        clearThrottledCallStore();
    });
}
